$(function () {

    window.onload = new function () {
        var popup = document.getElementById('custom-popup');
        if (popup && popup.style && popup.style.display == 'block') {
            $('#bg-opacity').addClass('opacity-active');
        }
    };

    $("#cancel-button-text").on('click', function (e) {
        $('#bg-opacity').removeClass('opacity-active').addClass('opacity-remove');
    });

    $("#close-msg-button").on('click', function (e) {
        $('#bg-opacity').removeClass('opacity-active').addClass('opacity-remove');
    });
});


